export default __webpack_public_path__ + "static/media/Stalker's Jerkin of Waning Dusk.2ae68321.jpg";